import { render } from "./Sv010.vue?vue&type=template&id=1f1e40b3&scoped=true"
import script from "./Sv010.vue?vue&type=script&lang=js"
export * from "./Sv010.vue?vue&type=script&lang=js"

import "./Sv010.vue?vue&type=style&index=0&id=1f1e40b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1e40b3"]])

export default __exports__